const data = [
  { id: "1", imageName: "сс_1.webp", tag: "Cartoon characters" },
  { id: "2", imageName: "сс_2.webp", tag: "Cartoon characters" },
  { id: "3", imageName: "сс_4.webp", tag: "Cartoon characters" },
  { id: "4", imageName: "сс_5.webp", tag: "Cartoon characters" },
  { id: "5", imageName: "сс_6.webp", tag: "Cartoon characters" },
  { id: "6", imageName: "сс_8.webp", tag: "Cartoon characters" },
  { id: "7", imageName: "сс_10.webp", tag: "Cartoon characters" },
  { id: "8", imageName: "dp_1.webp", tag: "Digital portraits" },
  { id: "9", imageName: "dp_2.webp", tag: "Digital portraits" },
  { id: "10", imageName: "dp_3.webp", tag: "Digital portraits" },
  { id: "11", imageName: "dp_4.webp", tag: "Digital portraits" },
  { id: "12", imageName: "dp_5.webp", tag: "Digital portraits" },
  { id: "13", imageName: "dp_6.webp", tag: "Digital portraits" },
  { id: "14", imageName: "dp_7.webp", tag: "Digital portraits" },
  { id: "15", imageName: "dp_8.webp", tag: "Digital portraits" },
  { id: "16", imageName: "dp_9.webp", tag: "Digital portraits" },
  { id: "17", imageName: "vp_2.webp", tag: "Vector portraits" },
  { id: "18", imageName: "vp_6.webp", tag: "Vector portraits" },
  { id: "19", imageName: "vp_3.webp", tag: "Vector portraits" },
  { id: "20", imageName: "vp_4.webp", tag: "Vector portraits" },
  { id: "21", imageName: "vp_5.webp", tag: "Vector portraits" },
  { id: "22", imageName: "vc_1.webp", tag: "Vector portraits" },
  { id: "23", imageName: "vc_2.webp", tag: "Vector portraits" },
  { id: "24", imageName: "vc_93.webp", tag: "Vector portraits" },
  { id: "25", imageName: "lf_1.webp", tag: "Posters" },
  { id: "26", imageName: "lf_2.webp", tag: "Posters" },
  { id: "27", imageName: "lf_3.webp", tag: "Posters" },
  { id: "28", imageName: "lf_4.webp", tag: "Posters" },
  { id: "29", imageName: "lf_7.webp", tag: "Posters" },
  { id: "30", imageName: "lf_8.webp", tag: "Posters" },
  { id: "31", imageName: "lf_9.webp", tag: "Posters" },
  { id: "32", imageName: "lf_10.webp", tag: "Posters" },
  { id: "33", imageName: "lf_11.webp", tag: "Posters" },
  { id: "34", imageName: "lf_12.webp", tag: "Posters" },
  { id: "35", imageName: "lf_13.webp", tag: "Posters" },
  { id: "36", imageName: "lf_15.webp", tag: "Posters" },
  { id: "37", imageName: "lf_16.webp", tag: "Posters" },
  { id: "38", imageName: "gdc_1.webp", tag: "Game design" },
  { id: "39", imageName: "gdc_2.webp", tag: "Game design" },
  { id: "40", imageName: "gdc_3.webp", tag: "Game design" },
  { id: "41", imageName: "gdc_4.webp", tag: "Game design" },
  { id: "42", imageName: "gdc_5.webp", tag: "Game design" },
  { id: "43", imageName: "gdc_10.webp", tag: "Game design" },
  { id: "44", imageName: "gdc_11.webp", tag: "Game design" },
  { id: "45", imageName: "gdC_6.webp", tag: "Game design" },
  { id: "46", imageName: "gdC_7.webp", tag: "Game design" },
  { id: "47", imageName: "gdC_8.webp", tag: "Game design" },
  { id: "48", imageName: "gdC_9.webp", tag: "Game design" },
  { id: "49", imageName: "gdC_93.webp", tag: "Game design" },
];

export default data;
